<template>
  <div class="bg-card bg-white border-card-border md:px-6">
    <div class="w-full pt-3">
      <div>
        <h1 slot="header" class="text-xl font-semibold pb-2 mt-5">Verify Micro-Deposits</h1>
        <h3 slot="header" class="pb-3 border-b mb-4">
          Two deposits of less than 20 cents have been deposited in your
          <span class="underline font-bold">{{ bankName }}</span> account. Please fill in those
          values below to verify your ownership of the account. Please note that it may take 1-3
          business days for the deposits to arrive in your account.
        </h3>
      </div>
    </div>
    <form autocomplete="on" novalidate>
      <div class="flex md:w-full mt-16 mb-3 px-2">
        <Input
          v-for="item in fieldOrder"
          v-bind:key="item"
          v-model="microDepositInformation[item].value"
          :error="microDepositInformation[item].error"
          :name="microDepositInformation[item].name"
          :placeholder="microDepositInformation[item].placeholder"
          :maxlength="microDepositInformation[item].maxlength"
          prefix="$"
          underlined="true"
          class="mb-2 w-1/2 md:w-1/3 mr-4"
        />
      </div>
    </form>
    <div class="flex w-full mt-4">
      <!-- <button
        class="hover:text-primary mr-auto focus:outline-none rounded"
        type="btn"
        aria-label="navigate back"
        v-on:click="handleBack()"
      >
        <i
          class="fas fa-arrow-left bg-gray-300 rounded-full flex items-center text-lg justify-center w-8 h-8"
        ></i>
      </button> -->

      <base-button
        type="primary ml-auto"
        :disabled="!nextEnabled"
        :loading="loading"
        aria-label="navigate next"
        @click="handleNext()"
      >
        Verify Account
      </base-button>
    </div>
    <transition name="in--up">
      <div
        class="flex items-center justify-center w-full px-4"
        v-if="globalErrorMessage.length > 0"
      >
        <h3 class="text-red-500 text-sm">{{ globalErrorMessage }}</h3>
      </div>
    </transition>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      microDepositInformation: {
        mdAmount1: {
          name: 'Amount 1',
          placeholder: '0.03',
          maxlength: 4,
          value: '',
          error: ''
        },
        mdAmount2: {
          name: 'Amount 2',
          placeholder: '0.09',
          maxlength: 4,
          value: '',
          error: ''
        }
      },
      fieldOrder: ['mdAmount1', 'mdAmount2'],
      bankName: this.$store.state.applicationData.bankName,
      globalErrorMessage: '',
      loading: false,
      firstClick: true
    }
  },
  computed: {
    amount1() {
      return this.microDepositInformation.mdAmount1.value
    },
    amount2() {
      return this.microDepositInformation.mdAmount2.value
    },
    fieldsValid() {
      const errorsExist = Object.keys(this.microDepositInformation).filter(
        (fn) => this.microDepositInformation[fn].error.length > 0
      )
      const emptyRequired = Object.keys(this.microDepositInformation).filter(
        (fn) =>
          !this.microDepositInformation[fn].optional &&
          this.microDepositInformation[fn].value.length === 0
      )
      return errorsExist.length + emptyRequired.length === 0
    },
    nextEnabled() {
      return this.firstClick || this.fieldsValid
    },
    microDepositValues() {
      return this.fieldOrder.map((k) => this.microDepositInformation[k].value)
    }
  },
  methods: {
    handleNext() {
      if (this.firstClick) {
        this.firstClick = false
        const emptyRequired = Object.keys(this.microDepositInformation).filter(
          (fieldName) =>
            !this.microDepositInformation[fieldName].optional &&
            this.microDepositInformation[fieldName].value.length === 0
        )
        if (emptyRequired.length > 0) {
          emptyRequired.forEach((requiredField) => {
            this.microDepositInformation[requiredField].error = 'This is a required field.'
          })
          this.globalErrorMessage = 'Please fix all errors before proceeding.'
          return
        }
      }
      this.loading = true
      const outputdata = {
        amount1: this.microDepositInformation.mdAmount1.value,
        amount2: this.microDepositInformation.mdAmount2.value
      }
      this.$store
        .dispatch('applicationData/verifies', outputdata)
        .then(() => this.$emit('next'))
        .catch((e) => {
          e = e.message ? e.message : e
          console.log(e)
          console.log(`FE Error in verifyMicroDeposits/handleNext: ${e}`)

          if (e.includes('Invalid amount') || e.includes('Wrong amount(s)')) {
            this.globalErrorMessage = 'At least one of the amounts was incorrect.'
          } else {
            this.globalErrorMessage = e
          }
        })
        .finally(() => (this.loading = false))
    }
  },
  watch: {
    microDepositValues: {
      deep: true,
      handler() {
        this.globalErrorMessage = ''
      }
    },
    amount1: {
      handler(v) {
        if (isNaN(v) || Number(v) > 0.2 || Number(v) < 0.01) {
          this.microDepositInformation.mdAmount1.error = 'Please enter a value under $0.20.'
        } else {
          this.microDepositInformation.mdAmount1.error = ''
        }
      }
    },
    amount2: {
      handler(v) {
        if (isNaN(v) || Number(v) > 0.2 || Number(v) < 0.01) {
          this.microDepositInformation.mdAmount2.error = 'Please enter a value under $0.20.'
        } else {
          this.microDepositInformation.mdAmount2.error = ''
        }
      }
    }
  }
}
</script>
